import React from "react";
import CustomPosts from "../misc/custom-posts/CustomPosts";
import { NewPostProps } from "./types";

const NewPost: React.FC<NewPostProps> = ({ isOpen, setIsOpen, getAllPosts }) => {
    return (
        <CustomPosts
            setIsOpen={setIsOpen}
            open={isOpen}
            isAdHoc={true}
            getAllPosts={getAllPosts}
        />
    );
};

export default NewPost;
